export class SeparatedUser {
  separatedUserId?: number;
  clientITProfileId?: number;
  name?: string;
  separationDate?: Date;
  accessRevoked?: boolean;
  revokationDate?: Date;
  signedName?: string;
  signedDate?: Date;
}
